if (typeof ShippingNotice !== "function") {
  class ShippingNotice extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
    init() {
      const freeShippingThreshold = Number(
        this.getAttribute("data-free-shipping")
      );
      //const cartTotal = Number(this.getAttribute("data-cart-total-amount"));

      const cartItems = JSON.parse(this.getAttribute("data-cart-items"));
      const cartTotal = cartItems ? this.calculateValidCartTotal(cartItems) : 0;

      if (cartTotal === 0) {
        this.innerHTML = ''; // Hide the component
        return;
    }

      const freeShippingRemaining =
        cartTotal -
        Math.round(
          freeShippingThreshold *
            (Shopify.currency.rate ? Number(Shopify.currency.rate) : 1)
        );
      let shippingMessage = "";
      let shippingSuccess = !1;
      if (freeShippingRemaining < 0) {
        shippingMessage =
          window.KROWN.settings.locales.shipping_notice_remaining_to_free.replace(
            "{{ remaining_amount }}",
            this._formatMoney(
              Math.abs(freeShippingRemaining),
              KROWN.settings.shop_money_format
            )
          );
      } else {
        shippingMessage =
          window.KROWN.settings.locales.shipping_notice_eligible_for_free;
        shippingSuccess = !0;
      }
      if (this.hasAttribute("data-show-alert")) {
        this.innerHTML = `
          <div class="alert alert--wide alert--${
            shippingSuccess ? "success" : "note"
          }">
            ${shippingMessage}
          </div>`;
      } else {
        this.innerHTML = shippingMessage;
      }
    }

    calculateValidCartTotal(cartItems) {
      // Check if all items in the cart are physical gift cards priced at 150 or more
      const isOnlyExpensiveGiftCards = cartItems.every(
        (item) =>
          item.handle === "physical-gift-card" && item.final_price / 100 >= 150
      );

      // If all items are physical gift cards priced at 150 or more, return 0 to hide the text
      if (isOnlyExpensiveGiftCards) {
        return 0;
      }

      return cartItems
        .filter(item => {
            // Exclude items with grams <= 0 or requires_shipping === false
            if (item.grams <= 0 || !item.requires_shipping) {
                return false;
            }
            
            // Exclude items where handle is "physical-gift-card" and price is 150 or above
            if (item.handle === "physical-gift-card") {
                return false;
            }
            
            return true;
        })
        .reduce((total, item) => total + item.final_line_price, 0); // Divide final_price by 100 before adding
    }
    _formatMoney(cents, format) {
      if (typeof cents === "string") {
        cents = cents.replace(".", "");
      }
      let value = "";
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || moneyFormat;
      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ",";
        decimal = decimal || ".";
        if (isNaN(number) || number === null) {
          return 0;
        }
        number = (number / 100.0).toFixed(precision);
        const parts = number.split(".");
        const dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands
        );
        const centsAmount = parts[1] ? decimal + parts[1] : "";
        return dollarsAmount + centsAmount;
      }
      switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);
          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
        case "amount_no_decimals_with_space_separator":
          value = formatWithDelimiters(cents, 0, " ");
          break;
        case "amount_with_apostrophe_separator":
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }
      return formatString.replace(placeholderRegex, value);
    }
  }
  if (typeof customElements.get("shipping-notice") == "undefined") {
    customElements.define("shipping-notice", ShippingNotice);
  }
}
